import type { Directive, DirectiveBinding } from "vue";

/**
 * v-element-appear-bubble 指令
 * 当元素进入视口时，添加从下往上的出现动画
 */
const elementAppearBubble: Directive = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        // 获取配置参数
        const options = {
            threshold: binding.value?.threshold ?? 0.05,
            rootMargin: binding.value?.rootMargin ?? "0px 0px -30px 0px",
        };

        // 添加初始状态类
        el.classList.add("animate-init");

        // 创建 IntersectionObserver
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const target = entry.target as HTMLElement;
                        // 移除初始状态类，添加动画类
                        target.classList.remove("animate-init");
                        target.classList.add("animate-bottom-to-top");
                        // 动画触发后停止观察该元素
                        observer.unobserve(target);
                    }
                });
            },
            {
                threshold: options.threshold,
                rootMargin: options.rootMargin,
            }
        );

        // 开始观察元素
        observer.observe(el);
    },
};

export default elementAppearBubble;
